'use client';

import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
import posthog from 'posthog-js';
import { useEffect } from 'react';

// Inicializa PostHog apenas no browser
if (typeof window !== 'undefined') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST!,
    autocapture: true, // captura pageviews e cliques automaticamente
  });
}

export function PostHogClient() {
  const { data: session } = useSession();
  const pathname = usePathname();

  // Identifica usuário e evento de login
  useEffect(() => {
    if (session?.email) {
      posthog.identify(session.email, {
        name: session.name,
        email: session.email,
        role: session.role,
      });
      posthog.capture('user_logged_in');
    }
  }, [session]);

  // Captura pageviews
  useEffect(() => {
    posthog.capture('$pageview', { path: pathname });
  }, [pathname]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target) return;

      const nameAttr =
        target.getAttribute('name') || target.getAttribute('data-name') || null;

      posthog.capture('element_clicked', {
        id: target.id || null,
        class: target.className || null,
        name: nameAttr, // pega name se existir
        page: window.location.pathname,
      });
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return null;
}

export default posthog;
